/*
Replace
nft with your resource Name :) Take care about different writings!
/!\ Nft nft Nfts nfts /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const roadmapsSlice = createSlice({
  name: "roadmaps",
  initialState: { ...defaultInitialState },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: (state, action) => {
      state.loadingShow = false;
      state.loadedShow = true;
      state.show = action.payload;
      state.showId = action.payload.id;
      state.dictionary[action.payload.id] = action.payload;
      state.errorsObject = null;
    },
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: defaultCreateSuccess,
    createFail: (state, action) => {
      state.creating = false;
      state.created = false;
      state.createError = true;
      if (action.payload?.data) {
        state.errorsObject = action.payload.data;
      } else {
        state.createErrorMessage = action.payload.message;
      }
    },
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: (state, action) => {
      state.updating = false;
      state.updated = false;
      state.updateError = true;
      if (action.payload?.data) {
        state.errorsObject = action.payload.data;
      } else {
        state.updateErrorMessage = action.payload.message;
      }
    },
    addToDictionary: defaultAddToDictionary,
    createSuccessReset: (state, action) => {
      state.created = false;
    },
    updateErrorReset: (state, action) => {
      state.updating = false;
      state.updated = false;
      state.updateError = null;
    },
    listErrorReset: (state, action) => {
      state.listing = false;
      state.listed = false;
      state.listError = null;
    },
    createErrorReset: (state, action) => {
      state.creating = false;
      state.created = false;
      state.createError = null;
    },
    showErrorReset: (state, action) => {
      state.showing = false;
      state.showed = false;
      state.showError = null;
    },
  },
});

export const {
  show: showRoadmap,
  update: updateRoadmap,
  list: listRoadmaps,
  create: createRoadmap,
  listErrorReset: listRoadmapsErrorReset,
  updateErrorReset: updateRoadmapErrorReset,
  createErrorReset: createRoadmapErrorReset,
  showErrorReset: showRoadmapErrorReset,
  createSuccessReset: createRoadmapSuccessReset,
} = roadmapsSlice.actions;
export const actions = roadmapsSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const roadmaps = (state) =>
  state.roadmaps.idsList.map((id) => state.roadmaps.dictionary[id]);
export const roadmap = (state) =>
  state.roadmaps.showId && state.roadmaps.dictionary[state.roadmaps.showId];
export const roadmapAttributes = (state) => roadmap(state)?.attributes;
export const roadmapRelationships = (state) => roadmap(state)?.relationships;
export const roadmapId = (state) => state.roadmaps.showId;

export const getRoadmap = createSelector(
  (state) => state.roadmaps.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getRoadmapAttributes = createSelector(
  (state) => state.roadmaps.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getRoadmapRelationships = createSelector(
  (state) => state.roadmaps.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getRoadmaps = createSelector(
  (state) => state.roadmaps.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export const getRoadmapFormData = createSelector(
  (state) => state.roadmaps.dictionary,
  (state) => state.milestones.dictionary,
  (_, id) => id,
  (roadmapsDictionary, milestonesDictionary, id) => {
    const roadmapData = { ...roadmapsDictionary[id]?.attributes };

    const milestoneIds = roadmapsDictionary[
      id
    ]?.relationships?.milestones?.data?.map((milestone) => milestone?.id);

    roadmapData["milestones_attributes"] = milestoneIds?.map((milestoneId) => {
      return {
        milestone_id: milestoneId,
        ...milestonesDictionary[milestoneId]?.attributes,
      };
    });

    return roadmapData;
  }
);

export const getRoadmapBySlug = createSelector(
  (state) => state.roadmaps.dictionary,
  (_, slug) => slug,
  (dictionary, slug) => {
    return dictionary[
      Object.keys(dictionary).find(
        (key) =>
          dictionary[key]?.attributes?.slug === slug
      )
    ];
  }
);

export const getRoadmapIdBySlug = createSelector(
  (state) => state.roadmaps.dictionary,
  (_, slug) => slug,
  (dictionary, slug) => {
    return dictionary[
      Object.keys(dictionary).find(
        (key) =>
          dictionary[key]?.attributes?.slug === slug
      )
    ]?.id;
  }
);

export const getRoadmapAttributesBySlug = createSelector(
  (state) => state.roadmaps.dictionary,
  (_, slug) => slug,
  (dictionary, slug) => {
    return dictionary[
      Object.keys(dictionary).find(
        (key) =>
          dictionary[key]?.attributes?.slug === slug
      )
    ]?.attributes;
  }
);

export const getRoadmapRelationshipsBySlug = createSelector(
  (state) => state.roadmaps.dictionary,
  (_, slug) => slug,
  (dictionary, slug) => {
    return dictionary[
      Object.keys(dictionary).find(
        (key) =>
          dictionary[key]?.attributes?.slug === slug
      )
    ]?.relationships;
  }
);

export default roadmapsSlice.reducer;
